import React from 'react';

export const Owner = ({ link, avatar, name, onClick }) => (
  <a
    className="ais-Hit-ownerLink"
    href={link}
    onClick={e => {
      if (onClick && !(e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        onClick(name);
      }
    }}
  >
    
    {name}
  </a>
);



// WEBPACK FOOTER //
// ./components/Owner.js